
import { get, post } from "../api_helper";
import * as url from "../url_helper"
import { ACTIVE_INQUIRIES_VIEW_DETAILS_API, QUOTATIONS_LIST_BY_ID, VIEW_BIDS_SUMMARY_API } from "../url_helper";

export const postQuotationSummerySer = (data) => post(url.QUOTATION_SUMMERY, data);
export const getQuotationSummerySer = (data) => get(url.QUOTATION_SUMMERY + data);
export const getQuotationSummeryByIdSer = (data) => get(url.QUOTATION_SUMMERY + data);
export const getQuotationHistoryByIdSer = (data) => get(url.QUOTATION_HISTORY + data);
export const getQuotationSellerListByIdSer = (data) => get(url.QUOTATIONS_LIST_BY_ID + data);

export const getNetworkInquiriesSummaryApiCall = (data) => get(url.MARKET_PLACE_INQUIRIES + data);

export const getNetworkInquiriesViewBidSummaryApiCall = (data) => get(url.VIEW_BIDS_SUMMARY_API + data);

export const getActiveNetworkInquiriesViewDetailsApiCall = (data) => get(url.ACTIVE_INQUIRIES_VIEW_DETAILS_API + data);

export const getFreightLeadsStatsApiCall = () => get(url.FREIGHT_LEADS_STATS_API);

export const bookingStatusUpdateApiCall = (data) => post(url.BOOKING_STATUS_UPDATE_API, data);

//export const getQuotationSellerListByIdSer = (data) => get(url.QUOTATIONS_LIST_BY_ID+data);


export const postTransferStatusSer = (data) => post(url.POST_TRANSFER_STATUS + data);

export const getDashBoardQuotionSummerySer = () => get(url.DAHSBOARD_QUOTATION_SUMMERY)

export const postUpdateQuotionStatusSer = (data) => post(url.UPDATE_QUOTATION_STATUS, data);

export const postUpdateQuotionAssingToSer = (data) => post(url.UPDATE_QUOTATION_ASSIGN_TO, data);

export const getAllQuotationComparisonSer = (data) => get(url.GET_ALL_QUOTATION_COMPARISON + data);
